export default {
  templateCategories: [
    // { name: 'trending', title: 'trending now', description: 'get inspired by others', img: '/images/sample/trend.svg' },
    // { name: 'must_have', title: 'must have', description: 'turn chaos into order', img: '/images/sample/must.svg' },
    { name: 'wealth', title: 'work & finances', description: 'take control of your career and budget', img: '/images/sample/wealth.svg' },
    { name: 'spirituality', title: 'mindfulness & calmness', description: 'establish peace and harmony', img: '/images/sample/spirituality.svg' },
    { name: 'health', title: 'healthy body & mind', description: 'maintain a healthy quality of life', img: '/images/sample/health.svg' },
    { name: 'growth', title: 'knowledge & productivity', description: 'invest in yourself', img: '/images/sample/growth.svg' },
    { name: 'relationships', title: 'love & family', description: 'develop positive relationships', img: '/images/sample/relationships.svg' },
    { name: 'play', title: 'travel & hobbies', description: 'feel joyful and take on new challenges', img: '/images/sample/play.svg' },
  ],


  routines: [
    { title: 'Save at least 10% of my income💰', templateCategories: ['wealth'], frequency_count: 1, frequency_period: 'month'},
    { title: 'Invest at least 10% of my income 💸', templateCategories: ['wealth'], frequency_count: 1, frequency_period: 'month'},
    { title: 'Track and evaluate weekly expenses 💸', templateCategories: ['wealth'], frequency_count: 1, frequency_period: 'week'},
    { title: 'Create a shopping list 🛒', templateCategories: ['wealth'], frequency_count: 1, frequency_period: 'week'},
    { title: 'Quick networking 🤝', templateCategories: ['wealth'], frequency_count: 1, frequency_period: 'week'},
    { title: 'Plan my spending and prevent impulsive purchases 💸', templateCategories: ['wealth']},

    { title: 'Practise gratitude 🙏', templateCategories: ['spirituality']},
    { title: 'No screen time 1 hour before bedtime 🤳', templateCategories: ['spirituality']},
    { title: 'Do a deep breathing exercise 💨', templateCategories: ['spirituality']},
    { title: 'Inbox zero 📭', templateCategories: ['spirituality']},
    { title: 'Write in journal 📓 ', templateCategories: ['spirituality']},
    { title: 'Spend time with myself 🛀', templateCategories: ['spirituality']},
    { title: 'Meditation 🧘 ', templateCategories: ['spirituality']},
    { title: 'Get up early 🕕', templateCategories: ['spirituality']},
    { title: 'Evaluate myself 📖', templateCategories: ['spirituality']},
    { title: 'Spend 5 minutes in silence 🔒', templateCategories: ['spirituality']},
    { title: 'Set a cyclic alarm and wake up autopilot 🤖', templateCategories: ['spirituality']},
    { title: 'Take a cold shower 🚿', templateCategories: ['spirituality']},
    { title: 'Reduce social-media exposure 📴', templateCategories: ['spirituality']},
    { title: 'No multitasking 📈', templateCategories: ['spirituality']},

    { title: 'Check posture 🙇‍♀️', templateCategories: ['health'] },
    { title: 'Go to sleep by 11pm 🌔', templateCategories: ['health'] },
    { title: 'Sleep for 8 hours 😴', templateCategories: ['health'] },
    { title: 'A bowl or a smoothie of fruits and veggies 🍊', templateCategories: ['health'] },
    { title: 'Limit sugar 🐽', templateCategories: ['health'] },
    { title: 'Take vitamins that my body needs 💊', templateCategories: ['health'] },
    { title: 'Eat a healthy meal 🥗', templateCategories: ['health'] },
    { title: 'Go for a swim 🏊‍♀️', templateCategories: ['health'] },
    { title: 'Go for a run 🏃', templateCategories: ['health'] },
    { title: 'Morning exercise 🙆', templateCategories: ['health'] },
    { title: 'Balance on something 👣', templateCategories: ['health'] },
    { title: 'Drink a glass of water in the morning 💧', templateCategories: ['health'] },
    { title: 'Mindful eating (focus only on my meal) 🍜', templateCategories: ['health'] },
    { title: 'Exercise within my comfort zone 🏋️‍♀️ ', templateCategories: ['health'] },
    { title: 'Stretch my body 🤸‍♂️', templateCategories: ['health'] },
    { title: 'Ride a bike 🚴', templateCategories: ['health'] },
    { title: 'Guided Yoga 🧘‍♀️', templateCategories: ['health'] },
    { title: 'Drink at least 2 liters of water 💧', templateCategories: ['health'] },
    { title: 'Eat a healthy breakfast 🥗', templateCategories: ['health'] },
    { title: 'Take a cold shower 🚿', templateCategories: ['health'] },
    { title: 'Make myself a smoothie 🥕', templateCategories: ['health'] },
    { title: 'Go to the bed at the same time 🛌', templateCategories: ['health'] },


    { title: '30-minutes of little tasks ✔️', templateCategories: ['growth'] },
    { title: 'Read a book 📖', templateCategories: ['growth'] },
    { title: 'Learn and memorize a new word 🆕', templateCategories: ['growth'] },
    { title: 'Learn a new language 🧙', templateCategories: ['growth'] },
    { title: 'Practice coding 👩‍💻', templateCategories: ['growth'] },
    { title: 'An online course 💻', templateCategories: ['growth'] },
    { title: 'The hardest or most unappealing tasks first 🔬', templateCategories: ['growth'] },
    { title: 'Memorize something new 🧠', templateCategories: ['growth'] },
    { title: 'Practise speed reading 📚', templateCategories: ['growth'] },
    { title: 'Eat the frog - do the most difficult task first ⚡️', templateCategories: ['growth'] },
    { title: 'Set 3 priority tasks per day 🎯', templateCategories: ['growth'] },
    { title: 'Evaluate my day 📊', templateCategories: ['growth'] },
    { title: 'Practise visualizations 👨‍🎨', templateCategories: ['growth'] },

    { title: 'Walk together 🚶', templateCategories: ['relationships'] },
    { title: 'Quality time with close ones ❤️', templateCategories: ['relationships'] },
    { title: 'Tend to the garden 🌳', templateCategories: ['relationships'] },
    { title: 'Do my laundry 🧺', templateCategories: ['relationships'] },
    { title: 'Clean up my mess 🧹', templateCategories: ['relationships'] },
    { title: 'Tech-free time 📴', templateCategories: ['relationships'] },
    { title: 'Eat together 🍲', templateCategories: ['relationships'] },


    { title: 'Explore new place ⛺️', templateCategories: ['play'] },
    { title: 'Learn to play an instrument 🎸', templateCategories: ['play'] },
    { title: 'Learn juggling 🤹‍♂️', templateCategories: ['play'] },
    { title: 'Take a picture everyday 📷', templateCategories: ['play'] },
    { title: 'Practice a new skill 🤹‍♂️', templateCategories: ['play'] },
    { title: 'Dance 💃🕺', templateCategories: ['play'] },
    { title: 'Say thank you 🔓', templateCategories: ['play'] },
    { title: 'Call my parents ☎️ ', templateCategories: ['play'] },

  ]
}
